export enum Role {
    Collaborator = 1,
    Admin = 2,
    Owner = 1024,
}
